import { call, takeEvery, all } from 'redux-saga/effects';

import * as types from './types';
import * as api from './api';
import { findGenerator } from 'helpers/resourceSagas';

export const findProduct = findGenerator({
  resourceType: 'products',
  endpoint: api.findProduct
});

export function* watchFindProduct() {
  yield takeEvery(types.FIND_PRODUCT, findProduct);
}


export function* watchProducts() {
  yield all([
    call(watchFindProduct),
  ]);
}
